import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { getFundDetails, getFunds } from "./actions";
import moment from 'moment';
import Select from "react-select";
// import { Row, Col } from "antd";
import { getNumberWithUnit } from "@hedgefund/shared";

const FundCompare = ({ match }) => {
  const customStyles = {
    control: (provided, state) => ({
      ...provided,
      marginRight: "10px",
      marginTop: "40px"
    }),
  };
  const [fundData, setFundData] = useState();
  const fundId = match.params.id;
  const dispatch = useDispatch();
  const fundCompareState = useSelector((state) => state.fundCompare);
  const {
    fund,
    funds
  } = fundCompareState;

  const items = [
    ...funds.map((u) => ({
      id: u.id,
      name: u.name,
      isSelected: false,
    }))
  ]

  useEffect(() => {
    if (fundId) {
      dispatch(getFundDetails(fundId));
    }
    dispatch(getFunds());
  }, [fundId]);

  useEffect(() => {
    const data = items.map((y) => {
      const num = Number(fundId);
      if (y.id === num) {
        y.isSelected = true;
      }
      return y;
    });

    setFundData(data.filter(z => z.isSelected === false))
  }, [funds])

  const GetSelectedFund = (e) => {
    const data = fundData.map((y) => {
      const num = Number(e.value);
      if (y.id === num) {
        y.isSelected = true;
      }
      return y;
    });
    setFundData(data.filter(z => z.isSelected === false));
    dispatch(getFundDetails(e.value));
  }

  return (
    <main>
      <div className="main-inner">
        <div className="container-fluid mt-5">
          <h2>Fund Comparison </h2>
          <div className="fundCompare">
            <ul >
              <li>
                {fundData?.length > 0 && (
                  <Select
                    styles={customStyles}
                    className="comparison-dropdown"
                    value={{ value: "Choose Fund", label: "Choose Fund" }}
                    onChange={(e) => GetSelectedFund(e)}
                    options={fundData?.map(it => ({ value: it.id, label: it.name }))}
                  />
                )}
              </li>
              {fund?.map((ut) => {
                return (
                  <li><a class="comparison-item-thumb" href={"fund/" + ut.id}>
                    <img style={{ height: "100px", width: "200px" }} src={ut?.logo ? ut?.logo : "https://www.bootdey.com/image/200x200/FF0000/00000"} alt="Logo" />
                  </a><br />{ut?.name}</li>
                )
              })
              }

            </ul>
            <ul >
              <li>Company</li>
              {fund?.map((item) => <li>{item?.companyName ? item?.companyName : "N/A"}</li>)}

            </ul>
            <ul >
              <li>Strategy</li>
              {fund?.map((item) => <li>{item?.strategyName ? item?.strategyName : "N/A"}</li>)}

            </ul>
            <ul >
              <li>Description</li>
              {fund?.map((item) => <li>{item?.description ? item?.description : "N/A"}</li>)}

            </ul>

            <ul >
              <li>Regions</li>
              {fund?.map((item) => <li>{item?.regions.length > 0 ? item?.regions?.map((item) => { return (item.name + ", ") }) : "N/A"}</li>)}

            </ul>
            <ul >
              <li>Location</li>
              {fund?.map((item) => <li>{item?.location ? item?.location : "N/A"}</li>)}

            </ul>
            <ul >
              <li>Annualized Return</li>
              {fund?.map((item) => <li>{item?.annualReturn ? item?.annualReturn.toFixed(2) : "N/A"}</li>)}

            </ul>
            <ul >
              <li>Annual Volatility</li>
              {fund?.map((item) => <li>{item?.annualVolatility ? item?.annualVolatility.toFixed(2) : "N/A"}</li>)}

            </ul>
            <ul >
              <li>Inc. Date</li>
              {fund?.map((item) => <li>{item?.initializationDate ? moment(item?.initializationDate).format("DD MMM YYYY") : "N/A"}</li>)}

            </ul>

            <ul >
              <li>AUM</li>
              {fund?.map((item) => <li>{item?.aum ? getNumberWithUnit(item?.aum) : "N/A"}</li>)}

            </ul>
            <ul >
              <li>Monthly Return</li>
              {fund?.map((item) => <li>{item?.monthlyReturn ? item?.monthlyReturn?.toFixed(2) : "N/A"}</li>)}

            </ul>
            <ul >
              <li>YTD Return</li>
              {fund?.map((item) => <li>{item?.annualVolatility ? item?.annualVolatility?.toFixed(2) : "N/A"}</li>)}

            </ul>
            <ul >
              <li>Highlight</li>
              {fund?.map((item) => <li>{item?.highlight ? item?.highlight : "N/A"}</li>)}

            </ul>
          </div>
        </div>
      </div>
    </main>
  );
};

export default FundCompare;
